// @ts-nocheck
import { YStack, XStack, Text, Paragraph } from 'tamagui';
import { Container } from '../components/Container';
import { PageLayout } from '../components/PageLayout';

const experience = [
  { company: 'Physis', role: 'Fractional CTO', detail: 'Technical leadership and architecture' },
  { company: 'AWS', role: 'Senior engineer', detail: 'Hybrid networking control plane' },
  { company: 'Solo Funds', role: 'Staff engineer', detail: 'Fintech money movement platform' },
  { company: 'Plaid', role: 'Senior engineer', detail: 'Identity and risk systems' },
  { company: 'Meta', role: 'Senior engineer', detail: 'Infrastructure platform' },
];

export default function AboutPage({ theme, toggleTheme }) {
  return (
    <PageLayout theme={theme} toggleTheme={toggleTheme}>
      <Container>
        <YStack paddingVertical="$8" gap="$8" maxWidth={700}>
          {/* Header */}
          <YStack gap="$4">
            <Text fontSize="$2" color="$color6" textTransform="uppercase" letterSpacing={3} fontWeight="500">
              About
            </Text>
            <Text fontSize={40} fontWeight="700" color="$color12" lineHeight={48}>
              One founder. Ten years of building.
            </Text>
          </YStack>

          {/* Story */}
          <YStack gap="$4">
            <Paragraph fontSize="$5" color="$color10" lineHeight={28}>
              I'm Dan. I've spent the last decade building infrastructure — fintech ledgers,
              cloud control planes, cross-chain indexers, identity systems, and platform
              infrastructure at scale. The kind of work where failure means real money lost
              and real pages at 3am.
            </Paragraph>
            <Paragraph fontSize="$5" color="$color10" lineHeight={28}>
              Every product in the Romans portfolio exists because I hit the problem firsthand
              and wished the tool existed. Torch came from switching between too many apps.
              Statio came from watching AI agents call APIs with zero governance. Denarius came
              from wanting institutional-grade analysis without the institutional-grade price tag.
              JanusLedger came from years of building double-entry accounting systems in
              production fintech environments.
            </Paragraph>
          </YStack>

          {/* The Roman thing */}
          <YStack gap="$3" paddingVertical="$4" borderTopWidth={1} borderTopColor="$color4">
            <Text fontSize="$6" fontWeight="600" color="$color12">
              Why "Romans"?
            </Text>
            <Paragraph fontSize="$4" color="$color8" lineHeight={26}>
              I studied Classical Antiquities at Trinity College alongside Computer Science.
              The Roman naming isn't a gimmick — it's the design philosophy. The Romans built
              roads, aqueducts, and legal systems that lasted two thousand years. Not because
              they were clever, but because they were practical. They solved real problems with
              engineering that worked at scale.
            </Paragraph>
            <Paragraph fontSize="$4" color="$color8" lineHeight={26}>
              Every product is named after something a Roman soldier carried or a Roman engineer
              built. Torch (fax — the light), Statio (the checkpoint), Denarius (the coin),
              JanusLedger (Janus — the god who sees both sides), Pilum (the javelin),
              Scuta (the shield). Tools that are reliable, practical, and built to last.
            </Paragraph>
          </YStack>

          {/* Experience */}
          <YStack gap="$4" paddingVertical="$4" borderTopWidth={1} borderTopColor="$color4">
            <Text fontSize="$2" color="$color6" textTransform="uppercase" letterSpacing={3} fontWeight="500">
              Previously
            </Text>
            <YStack gap="$2">
              {experience.map((exp) => (
                <XStack
                  key={exp.company}
                  flexDirection="row"
                  gap="$4"
                  paddingVertical="$3"
                  borderBottomWidth={1}
                  borderBottomColor="$color3"
                  alignItems="baseline"
                >
                  <Text fontSize="$5" fontWeight="600" color="$color12" width={140} flexShrink={0}>
                    {exp.company}
                  </Text>
                  <YStack gap="$1" flex={1}>
                    <Text fontSize="$3" color="$color9">{exp.role}</Text>
                    <Text fontSize="$2" color="$color7">{exp.detail}</Text>
                  </YStack>
                </XStack>
              ))}
            </YStack>
          </YStack>

          {/* Links */}
          <XStack flexDirection="row" gap="$5">
            <Text
              fontSize="$3" color="$amber7" fontWeight="500"
              cursor="pointer" hoverStyle={{ opacity: 0.7 }}
              onPress={() => window.open('https://github.com/sid-technologies', '_blank')}
            >
              GitHub →
            </Text>
            <Text
              fontSize="$3" color="$amber7" fontWeight="500"
              cursor="pointer" hoverStyle={{ opacity: 0.7 }}
              onPress={() => window.open('https://logicalbytes.dev', '_blank')}
            >
              Personal Blog →
            </Text>
          </XStack>
        </YStack>
      </Container>
    </PageLayout>
  );
}
